module.exports = __webpack_public_path__ + "img/sponsor-carousel-riviera.372183c9.jpg";